import { hasGate } from 'commerce-billing-lib/public/utilities';
import { gate } from 'hub-http/gates';
export const useHasExpandedMultiCurrencyGate = () => hasGate(gate('Commerce:ExpandedMulticurrency'));
export const useHasDeleteScopeGate = () => hasGate(gate('Permissions:CommerceSubscriptions'));